module.exports = __webpack_public_path__ + "img/rule_bg.1768119790257.png";